/** Taken from https://next.orval.dev/guides/custom-axios. Adds cancellability to promises, and unpacks the
 * axios 'data' prop
 */

import Axios, { AxiosRequestConfig } from 'axios';

const baseURL = process.env['VITE_API_HOST'];

export const AXIOS_INSTANCE = Axios.create({ baseURL });

const customInstance = <T>(config: AxiosRequestConfig): Promise<T> => {
  const source = Axios.CancelToken.source();
  const promise = AXIOS_INSTANCE({ ...config, cancelToken: source.token }).then(({ data }) => data);

  AXIOS_INSTANCE.defaults.withCredentials = true;

  // @ts-expect-error This is taken straight from the example; seesm to be augmenting the built in Promise type with cancellability?
  promise.cancel = () => {
    source.cancel('Query was cancelled');
  };

  return promise;
};

export default customInstance;
